module.exports = __webpack_public_path__ + "static/img/jacket.580a773e.webp";